// tslint:disable-next-line: prettier
import React from "react";
export var HeaderContext = React.createContext(null);
//# sourceMappingURL=header-context.js.map